export const DEFAULT_MILAGE_VALUE = 15000;
